/* eslint-disable max-len */
import React from 'react'
import PropTypes from 'prop-types'

const Team = ({
    children, title,
}) => (
    <div className="team-wrapper" id="team">
        <div className="team-titles">
            <img src={title} alt="NFT Team" />
            <h2>{title}</h2>
        </div>

        <div className="team-gallery">
            {children}
        </div>
    </div>
)

Team.propTypes = {
    children: PropTypes.arrayOf(PropTypes.object).isRequired,
    title: PropTypes.string.isRequired,
}

export default Team
